module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.160e617a.eot";